export default {
    Title: 'Tham số báo cáo',
    ChoosePeriod: 'Chọn kỳ báo cáo',
    FromDate: 'Từ ngày',
    ToDate: 'Đến ngày',
    CodeAll: '<<Tất cả>>',
    NameAll: 'Tất cả',
    Year: 'Năm',
    All: 'Tất cả',
    SummaryCode: '<<Tổng hợp>>',
    Summary: 'Tổng hợp',
    Option: 'Tùy chọn',
    Source: 'Nguồn',
    Chapter: 'Chương',
    BudgetItem: 'Mục',
    BudgetSubItem: 'Tiểu mục',
    BudgetSubItemDetail: 'Tiết',
    BudgetSubKindItem: 'Khoản',
    BankAccount: 'Tài khoản',
    TemplateReport: 'Mẫu báo cáo',
    OptionsGetData: 'Tùy chọn lấy số liệu',
    FreeTemplate: 'Mẫu tự chủ',
    NotGetDataXDCB: 'Không lấy số liệu XDCB',
    PrintMonthSettlementAdjustment: 'In tháng chỉnh lý quyết toán',
    AndVoucherSettlementAdjustment: 'Bao gồm chứng từ chỉnh lý quyết toán',
    EstimateUsed: 'Dự toán đã sử dụng',
    GetWithDrawAndPayment: 'Lấy số rút thực chi và số thanh toán tạm ứng',
    GetWithDrawAndAdvance: 'Lấy số rút thực chi và rút tạm ứng',
    GetByFormulaSelfSetup: 'Lấy theo công thức tự thiết lập',
    SetupFormula: 'Thiết lập công thức',
    DisplayOption: 'Tùy chọn hiển thị',
    NextPageDown14: 'Các trang sau hạ thấp 1/4 trang',
    RowCountKBNN: 'Số dòng KBNN ghi',
    DisplayUnitInformation: 'Hiển thị thông tin đơn vị theo:',
    Period: 'Kỳ báo cáo',
    SelectAll: '<<Chọn tất>>',
  };
  